<div class="registration-stepper-container flex align-items-center justify-content-around py-3">
    <!-- Step 1 -->
    <div class="flex align-items-center gap-2 step-item" [ngClass]="{'active': currentStep === 1, 'completed': currentStep > 1, 'inactive': currentStep < 1}">
      <span class="step-circle flex align-items-center justify-content-center">
        <i *ngIf="currentStep > 1" class="pi pi-check text-xs font-bold"></i>
        <span *ngIf="currentStep <= 1">1</span>
      </span>
      <span class="step-label font-outfit text-sm">Find your plan</span>
    </div>

    <!-- Step 2 -->
    <div class="flex align-items-center gap-2 step-item" [ngClass]="{'active': currentStep === 2, 'completed': currentStep > 2, 'inactive': currentStep < 2}">
      <span class="step-circle flex align-items-center justify-content-center">
        <i *ngIf="currentStep > 2" class="pi pi-check text-xs font-bold"></i>
        <span *ngIf="currentStep <= 2">2</span>
      </span>
      <span class="step-label font-outfit text-sm">Add password</span>
    </div>

    <!-- Step 3 -->
    <div class="flex align-items-center gap-2 step-item" [ngClass]="{'active': currentStep === 3, 'completed': currentStep > 3, 'inactive': currentStep < 3}">
      <span class="step-circle flex align-items-center justify-content-center">
        <i *ngIf="currentStep > 3" class="pi pi-check text-xs font-bold"></i>
        <span *ngIf="currentStep <= 3">3</span>
      </span>
      <span class="step-label font-outfit text-sm">Verify</span>
    </div>
</div>
